import { Link, useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { Button } from "./ui/button";
import { useAuth } from "../lib/auth";
import { LogOut } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <nav className="sticky top-0 z-40 bg-white cv-border border-t-0 border-l-0 border-r-0">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-home"><Logo /></Link>
        <div className="flex items-center gap-3">
          <Link to="/pricing" className="font-sub font-bold hover:text-purple-600 hidden sm:block" data-testid="nav-pricing">Pricing</Link>
          {user ? (
            <>
              {user.role === "teacher" ? (
                <Link to="/teacher" data-testid="nav-teacher">
                  <Button className="bg-purple-500 hover:bg-purple-400 text-white cv-border cv-shadow-sm cv-press font-headings uppercase rounded-xl">Classroom</Button>
                </Link>
              ) : (
                <Link to="/dashboard" data-testid="nav-dashboard">
                  <Button className="bg-purple-500 hover:bg-purple-400 text-white cv-border cv-shadow-sm cv-press font-headings uppercase rounded-xl">Dashboard</Button>
                </Link>
              )}
              <button
                onClick={() => { logout(); navigate("/"); }}
                className="cv-border bg-white p-2 rounded-xl cv-shadow-sm cv-press"
                data-testid="nav-logout"
              ><LogOut size={18} /></button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login">
                <Button variant="ghost" className="cv-border bg-white cv-shadow-sm cv-press font-headings uppercase rounded-xl">Login</Button>
              </Link>
              <Link to="/signup" data-testid="nav-signup">
                <Button className="bg-yellow-400 hover:bg-yellow-300 text-black cv-border cv-shadow-sm cv-press font-headings uppercase rounded-xl">Get Started</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
